"use client"
import React, { useState } from "react";
import './style.css';
import { BsDot } from "react-icons/bs";


function SingleBlogView({ data, contributers }: any) {
  const [showFullDesc, setShowDescription] = useState(false);
  const [showReviewerDec, setReviewerrDescription] = useState(false);
  const [showContributerDesc, setContributerDesc] = useState(false);
  const [showDec, setShowDec] = useState(null)
  const handleToggle = (type: any) => {
    setShowDec(showDec === type ? null : type);
  };
  const toggleDescription = () => {
    setShowDescription(!showFullDesc);
  };
  const toggleContributerDesc = () => {
    setContributerDesc(!showContributerDesc);
  };

  const toggleReviewerrDescription = () => {
    setReviewerrDescription(!showReviewerDec)
  }
  const newDate = new Date(data.publishDate);
  const formattedDate = newDate.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });



  const isValidUrl = (url: any) => {
    try {
      new URL(url);
      return true;  // ✅ URL is valid
    } catch (error) {
      return false; // ❌ Invalid URL
    }
  };

  let finalImageUrl = 'https://d60jxomgr6xep.cloudfront.net/oodles-files/placeholderImg.webp';
  let finalAuthorImageUrl = ""
  let finalApprovedByImage = ""


  const imageParamsUpdate = (baseImageUrl: any, baseUrl: any, width: any, format: any, check: string) => {
    if (baseImageUrl != null && isValidUrl(baseImageUrl)) {
      const imageUrl = new URL(baseImageUrl, baseUrl);
      const imgData = new URLSearchParams(imageUrl.search);
      imgData.set("width", width);
      imgData.set("format", format);
      switch (check) {
        case 'blogImage':
          finalImageUrl = `${imageUrl.origin}${imageUrl.pathname}?${imgData.toString()}`;
          break;
        case 'authorImage':
          finalAuthorImageUrl = `${imageUrl.origin}${imageUrl.pathname}?${imgData.toString()}`;
          break;
        case 'approvedByImage':
          finalApprovedByImage = `${imageUrl.origin}${imageUrl.pathname}?${imgData.toString()}`;
          break;
        default:
          break;
      }
    }
  }

  const getContributerImg = (image: any) => {
    if (image != null && isValidUrl(image)) {
      const imageUrl = new URL(image, 'https://d29s1rvcos3ou4.cloudfront.net');
      const imgData = new URLSearchParams(imageUrl.search);
      imgData.set("width", '80');
      imgData.set("format", 'webp');
      return `${imageUrl.origin}${imageUrl.pathname}?${imgData.toString()}`;
    }
  }

  imageParamsUpdate(data.blogImage, 'https://dgroz127fvgad.cloudfront.net', '500', 'webp', 'blogImage')
  imageParamsUpdate(data.authorImage, 'https://d29s1rvcos3ou4.cloudfront.net', '80', 'webp', 'authorImage')
  imageParamsUpdate(data.approvedByImage, 'https://d29s1rvcos3ou4.cloudfront.net', '80', 'webp', 'approvedByImage')


  return (
    <>
      <div className="flex md:flex-row flex-col-reverse">
        <div className="md:w-[30%]">
          <div className="md:w-[90%]">
            <div className="h-full w-full mt-[2.3vw] authorReviewer">
              <div className="flex justify-center authorBox1 gap-2" onClick={() => handleToggle("author")}>
                <img
                  src={
                    finalAuthorImageUrl
                  }
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).src = "https://d60jxomgr6xep.cloudfront.net/oodles-files/user-dummy-pic.png";
                  }}
                  alt="Author Img"
                  width={30}
                  height={30}
                  className="w-[5.5vw] h-[5.5vw] rounded-full authorImg border border-[#70707054]"
                />
              </div>
              <div className={`text-[.85vw] text-[#707070] authorDesc text-center ${showDec != 'author' ? 'descHide' : ""}  ${showFullDesc ? '' : 'showMore'}`} dangerouslySetInnerHTML={{ __html: data.userDescription }} onClick={() => toggleDescription()}></div>
              <div className="authorTitleBox pt-3 text-right">
                <p className="text-[.95vw] text-[#2a2c2e] authorTitle"><span className="text-[#2f83c5]">{data.authorName}</span> (Author)</p>
                <p className="text-[.8vw] text-[#2a2c2e] authorTitle">{data?.authorDesignation}</p>
              </div>
            </div>
            {
              data.approvedByName != null && data.authorName != data.approvedByName && data?.authorDesignation != data.publishedByDesignation ?
                <>
                  <h6 className="pt-4 mt-1 text-[1.1vw]">Reviewer</h6>
                  <div className="h-full w-full  reviewer">
                    <div className="flex authorBox1 gap-2" onClick={() => handleToggle("reviewer")}>
                      <img
                        src={
                          finalApprovedByImage
                        }
                        onError={(e) => {
                          (e.currentTarget as HTMLImageElement).src = "https://d60jxomgr6xep.cloudfront.net/oodles-files/user-dummy-pic.png";
                        }}
                        alt="Author Img"
                        width={30}
                        height={30}
                        className="w-[3vw] h-[3vw] authorImg"
                      />
                      <div className="authorTitleBox">
                        <p className="text-[.85vw] text-[#000000] authorTitle">{data.approvedByName}</p>
                        <p className="text-[.85vw]  text-[#707070] authorTitle">{data.approvedByDesignation}</p>
                      </div>
                    </div>
                    <div className={`text-[.85vw] text-[#707070] authorDesc ${showDec != 'reviewer' ? 'descHide' : ""} ${showReviewerDec ? '' : 'showMore'}`} dangerouslySetInnerHTML={{ __html: data.approvedByDesc }} onClick={() => toggleReviewerrDescription()}></div>
                  </div>
                </>
                : ""
            }
            {contributers.length ? <h6 className="pt-4 text-[1.1vw]">Technical Contributors</h6> : ''}
            <div className="contributerBox">
              {contributers &&
                contributers?.map((item: any, index: any) => {
                  return (
                    <div className=" w-full contributor" key={index}>
                      <div className="flex authorBox1 gap-2" onClick={() => handleToggle("reviewer")}>
                        <img
                          src={
                            getContributerImg(item.image)
                          }
                          onError={(e) => {
                            (e.currentTarget as HTMLImageElement).src = "https://d60jxomgr6xep.cloudfront.net/oodles-files/user-dummy-pic.png";
                          }}
                          alt="Author Img"
                          width={30}
                          height={30}
                          className="w-[3vw] h-[3vw] authorImg"
                        />
                        <div className="authorTitleBox">
                          <p className="text-[.85vw] text-[#000000] authorTitle">{item.fullName}</p>
                          <p className="text-[.85/vw]  text-[#707070] authorTitle">{item.designation}</p>
                        </div>
                      </div>
                      <div className={`text-[.85vw] text-[#707070] authorDesc text-start ${showDec != 'reviewer' ? 'descHide' : ""} ${showContributerDesc ? '' : 'showDesMore'}`} dangerouslySetInnerHTML={{ __html: item.description }} onClick={() => toggleContributerDesc()}></div>
                    </div>

                  );
                })}
            </div>
          </div>
        </div>
        <div className="mx-auto my-6 flex flex-col gap-3 w-[70%] [@media(max-width:500px)]:w-[100%] [@media(max-width:500px)]:my-4">
          <h1 className="text-3xl text-[#2A2C2E] font-bold">{data.title}</h1>
          <div className="flex gap-1 items-center mt-1">
            <img
              src={
                finalAuthorImageUrl
              }
              alt="Author Img"
              width={30}
              height={30}
              className="w-6 h-6 rounded-full border border-[#3283C5] border-1"
            />
            <div className="text-[#707070]-500 text-[0.9rem]">{data.authorName}</div>
            <span className="text-[#707070]-500 flex items-center">
              <BsDot />
              <div className="text-[#707070]-500 text-[0.9rem]">{formattedDate}</div>
            </span>
          </div>
          <div className="w-full h-[35vw] newImgHeight relative">
            <img
              src={
                finalImageUrl
              }
              alt="Blog Img"
              width={500}
              height={100}
              className="w-full h-full"
            />
            {
              data?.isAiGenerated && (
                <div className="aiGen">
                  AI Generated
                </div>
              )
            }
          </div>
          <div className="flex gap-4 my-2 flex-wrap">
            {data.areaOfWork != "" ? (
              <div className="flex gap-1 bg-[#EFF6FC] p-2 rounded-2xl w-fit">
                <div className="font-bold text-sm">Area Of Expertise:</div>
                <div className="text-[#2F83C5] text-sm" title={data.areaOfWork.join(", ")}>
                  {data.areaOfWork?.[0] +
                    (data.areaOfWork?.length > 1 ? ", " + data.areaOfWork[1] : "") +
                    (data.areaOfWork?.length > 2 ? " +" + (data.areaOfWork?.length - 2) + " more" : "")}
                </div>
              </div>
            ) : (
              ""
            )}
            {
              data.technlogy?.length != 0 ?
                <div className="flex gap-1 bg-[#EFF6FC] p-2 rounded-2xl">
                  <div className="font-bold text-sm">Technology:</div>
                  <div className="text-[#2F83C5] text-sm" title={data.technlogy.join(", ")}>
                    {Array.isArray(data.technlogy) && data.technlogy?.length !== 0
                      ? data.technlogy[0] +
                      (data.technlogy?.length > 1 ? ", " + data.technlogy?.[1] : "") +
                      (data.technlogy?.length > 2
                        ? " +" + (data.technlogy?.length - 2) + " more"
                        : "")
                      : "None"}
                  </div>
                </div> : ""
            }

          </div>
          <div
            className="editblog"
            dangerouslySetInnerHTML={{ __html: data.body }}
          ></div>

        </div>
      </div>
    </>
  );
}

export default SingleBlogView;
